import { LINK_TARGET_MODES } from "@/assets/utilities/tinymce/constants";

// Replaces TinyMCE's built-in link bar (needs link_context_toolbar: false): its theme shows only one
// context form per node, so target buttons can't be appended — the bar is re-registered with them added. 

export function registerLinkContextForm(editor) {
  const getSelectedLink = () => editor.dom.getParent(editor.selection.getNode(), "a[href]");

  const targetButtonApis = new Map();
  const syncTargetButtons = () => {
    const link = getSelectedLink();
    const target = link ? link.getAttribute("target") || "" : "";
    const current = target === "_self" ? "" : target;
    targetButtonApis.forEach((api, value) => api.setActive(value === current));
  };

  editor.ui.registry.addContextForm("linkWithTarget", {
    launch: { type: "contextformtogglebutton", icon: "link", tooltip: "Link" },
    label: "Link",
    predicate: node => !!editor.dom.getParent(node, "a[href]"),
    initValue: () => {
      const link = getSelectedLink();
      return link ? link.getAttribute("href") || "" : "";
    },
    commands: [
      {
        type: "contextformtogglebutton",
        icon: "link",
        tooltip: "Link",
        primary: true,
        onSetup: api => {
          api.setActive(!!getSelectedLink());
          return () => {};
        },
        onAction: formApi => {
          const link = getSelectedLink();
          if (link) {
            const href = formApi.getValue();
            editor.dom.setAttrib(link, "href", href);
            editor.dom.setAttrib(link, "data-mce-href", href);
            editor.undoManager.add();
            editor.fire("change");
          }
          formApi.hide();
        },
      },
      {
        type: "contextformbutton",
        icon: "unlink",
        tooltip: "Remove link",
        onAction: formApi => {
          editor.execCommand("unlink");
          editor.fire("change");
          formApi.hide();
        },
      },
      {
        type: "contextformbutton",
        icon: "new-tab",
        tooltip: "Open link",
        onAction: formApi => {
          const link = getSelectedLink();
          if (link) window.open(link.href, "_blank", "noopener");
          formApi.hide();
        },
      },
      ...LINK_TARGET_MODES.map(mode => ({
        type: "contextformtogglebutton",
        text: mode.text,
        onSetup: api => {
          targetButtonApis.set(mode.value, api);
          syncTargetButtons();
          return () => targetButtonApis.delete(mode.value);
        },
        onAction: () => {
          const link = getSelectedLink();
          if (!link) return;
          editor.dom.setAttrib(link, "target", mode.value || null);
          editor.undoManager.add();
          editor.fire("change");
          syncTargetButtons();
        },
      })),
    ],
  });
}
